module.exports = __webpack_public_path__ + "static/media/NeueMachina-Ultrabold.5f37678f.otf";